import { render, staticRenderFns } from "./LabelIcon.vue?vue&type=template&id=45c6ef40&"
import script from "./LabelIcon.vue?vue&type=script&lang=ts&"
export * from "./LabelIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports